// deno-fmt-ignore-file
import { StringKey } from '../../types/record.mjs';
import { CreateRecord } from './record_create.mjs';
export function FromAnyKey(value) {
    return CreateRecord(StringKey, value);
}
